import { render } from "./ModalConnectGHN.vue?vue&type=template&id=2344498f"
import script from "./ModalConnectGHN.vue?vue&type=script&lang=js"
export * from "./ModalConnectGHN.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__